import { cEl } from '../../../../util';

function StaticContentsContainer() {
    const container = cEl('div');
    container.classList.add('static-container');
    return container;
}

export default StaticContentsContainer;
